import React from 'react';
import ScrollingPopularGameContainer, {
  IScrollingPopularGameContainer,
} from '@wearesection/bandai-react-components/organisms/ScrollingPopularGameContainer';
import * as Types from 'graphql/types';
import {ComponentPropsAdapter} from '../../types';
import {convertPlatformToIcon, handleFilterTags, handleReturnSubtitleLanguage} from '~/utils';
import {GetRouter} from '~/utils';
import RenderNextImage from '../../atoms/render-next-image';
import {PLACEHOLDER_IMG} from '~/constants';
import {Box} from '@mui/material';

type PopularGameContainer = Types.GamesListing &
  IScrollingPopularGameContainer & {
    locale?: string;
  };

const adapter: ComponentPropsAdapter<
  PopularGameContainer,
  IScrollingPopularGameContainer
> = data => {
  const {pathname, locale} = GetRouter();
  return {
    title: data?.title ?? '',
    listPopularCard:
      data?.listItemCollection?.items?.map(item => ({
        title: item?.title ?? '',
        linkHref: `/${locale}${pathname}/${item?.slug}` ?? '',
        mainImage:
          item?.mainThumbnailImg?.media?.url ||
          item?.mastheadBackgroundImage?.media?.url ||
          PLACEHOLDER_IMG,
        mainImageNext: (
          <Box>
            <RenderNextImage
              src={
                item?.mainThumbnailImg?.media?.url ||
                item?.mastheadBackgroundImage?.media?.url ||
                PLACEHOLDER_IMG
              }
              width={336}
              height={336}
              alt={item?.title || ''}
            />
          </Box>
        ),
        tags:
          handleFilterTags(item?.platform as []).map((item: any) => ({
            color: '#737373',
            title: React.createElement(convertPlatformToIcon(item)),
            disabled: false,
          })) || [],
        locale: handleReturnSubtitleLanguage(item?.subtitle || [], locale),
      })) ?? [],
  };
};

const PADDING_COMPONENT: any = {
  '/games': {
    paddingTop: {
      xs: '72px',
      lg: '40px',
    },
    paddingBottom: {
      xs: '72px',
      lg: '40px',
    },
  },
};

const ScrollingPopularGameContainerOrganisms: React.FC<PopularGameContainer> = props => {
  const ComponentProps = adapter(props);
  const {pathname} = GetRouter();
  return (
    <Box sx={PADDING_COMPONENT[pathname] ?? {}}>
      <ScrollingPopularGameContainer {...ComponentProps} />
    </Box>
  );
};

export default ScrollingPopularGameContainerOrganisms;
